import React from 'react';
import './showDrawer.less';

class ShowDrawer extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isShowDailog: props.showModal,
            isHideCancleBtn: props.isShowCancleBtn ? props.isShowCancleBtn : false,
            sureBtnName: props.sureBtnName ? props.sureBtnName : "确定",
            title: props.titleName ? props.titleName : "确定",
            width: props.width ? props.width : "650px",
            hideBtn: props.hideBtn ? props.hideBtn : false,
            showLeftTopBtn: props.showLeftTopBtn ? props.showLeftTopBtn : false,
            skin: props.skin ? props.skin : "",
            wrapSkin: props.wrapSkin ? props.wrapSkin : "",
            hideTitle: props.hideTitle ? props.hideTitle : false,
            zIndex: props.zIndex ? props.zIndex : 1000,
            height: props.height ? props.height : '100%',
        };

    }
    componentWillReceiveProps(props) {  //监听父元素 传过来值的变化 触发的函数
        this.setState({
            isShowDailog: props.showModal,
            title: props.titleName ? props.titleName : "确定",
            width: props.width ? props.width : "650px",
        })

    }
    cancel = () => {
        this.setState({
            isShowDailog: false
        }, () => {
            if (typeof this.props.cancelDailog == "function") {
                this.props.cancelDailog();
            }
        })
    }

    render() {
        let elems =
            this.state.isShowDailog ?
                <div className={"showDrawerWrap " + this.state.wrapSkin} style={{ zIndex: this.state.zIndex }}>
                    <div className={"showDrawerWrap-box " + this.state.skin} style={{ width: this.state.width }}>
                        {
                            !this.state.hideTitle ?
                                <div className="showDrawerWrap-box-title">
                                    <span>
                                        {this.state.title}
                                    </span>
                                    <i className="iconfont icon-jia-copy1" onClick={() => this.cancel()}></i>
                                </div> : null
                        }
                        <div className="showDrawerWrap-box-main" style={{height: this.state.height}}>
                            {
                                this.props.children ?
                                    this.props.children : this.props.content ? this.props.content : '确认'
                            }
                        </div>
                    </div>
                </div> : null
        return (
            elems
        );
    }
}

export default ShowDrawer;



// WEBPACK FOOTER //
// ./src/components/showDrawer/index.jsx